import { NextLayoutComponentType } from 'next';
import nookies from 'nookies';

import withConditionalRedirect from '@simplecy/frontend-types/components/HOC/withConditionalRedirect';
import { userIsLoggedIn } from '@simplecy/frontend-types/hooks/useAuth';

const withGuestRequired = <T extends object>(
  Component: NextLayoutComponentType<T>,
  location?: string,
) => {
  const WithAuthWrapper: NextLayoutComponentType<T> = (props) => {
    return <Component {...props} />;
  };
  const WithAuthRedirectWrapper = withConditionalRedirect<T>({
    Component: WithAuthWrapper,
    clientCondition: () => userIsLoggedIn(),
    serverCondition: (ctx) => {
      const cookies = nookies.get(ctx);
      if (cookies?.ssoSession) {
        try {
          return !!JSON.parse(Buffer.from(cookies.ssoSession, 'base64').toString('ascii'))
            ?.accessToken;
        } catch (e) {
          return false;
        }
      }
      return false;
    },
    location: () => location ?? '/',
  });
  WithAuthRedirectWrapper.getLayout = Component.getLayout;
  return WithAuthRedirectWrapper;
};

export default withGuestRequired;
